module.exports = "<div class=\"banners-container\">\r\n    <div class=\"banner-wrapper\">\r\n        <div class=\"most-played\">\r\n            <ul>\r\n                <li>\r\n                    laa\r\n                </li>\r\n            </ul>\r\n        </div>\r\n        <div class=\"mini-carousel\">\r\n\r\n        </div>\r\n    </div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/Users/beyn/Documents/GitLab/spinmatic-casino/src/app/Modules/Shared/components/most-played/most-played.component.html
// module id = ../../../../../src/app/Modules/Shared/components/most-played/most-played.component.html
// module chunks = main